<template>
  <div class="home" v-auto-height="60">
    <el-alert
      title=""
      type="warning"
      show-icon
    >
      <p slot="title" style="font-size: 16px;">
        温馨提示：本平台不支持付费开通账号，所有声称可付费开通数字音乐管理平台账号的行为都是诈骗！请大家注意防范，切勿轻信。如遇到类似情况，可通过本平台首页反馈功能或<a :href="void(0)">qqmusic155@tencent.com</a>进行反馈。
      </p>
    </el-alert>
    <div class="home_block1">
      <!-- AI发行入口 -->
      <section v-if="showAiSkip" class="skip-wrapper">
        <img src="@/assets/images/ai_skip_icon.png" alt="ai_publish_entry" @click="handleSkipAi">
        <i class="el-icon-close" @click.stop="showAiSkip = false" />
      </section>

      <!-- swiper -->
      <el-carousel class="banner-swiper" height="700px" :interval="10 * 1000">
        <el-carousel-item key="banner1">
          <picture>
            <source srcset="@/assets/images/banner1.webp" type="image/webp">
            <img
              class="banner-swiper__bg"
              src="@/assets/images/banner1.png"
              alt="banner1"
              width="1180"
              height="700"
              fetchpriority="high"
            >
          </picture>
          <section class="banner-swiper__content">
            <h3>腾讯音乐娱乐<br>数字音乐管理平台</h3>
            <p>
              一站式音乐解决方案提供商。基于腾讯音乐亿级正版曲库，<br>提供内容管理、自助发行、版权保护、收益结算等专业服务。
            </p>
            <el-button type="primary" size="large" @click="handleClick('person')">{{ homeBtnText1 }}</el-button>
          </section>
        </el-carousel-item>
        <el-carousel-item key="banner2">
          <picture>
            <source srcset="@/assets/images/banner2.webp" type="image/webp">
            <img
              class="banner-swiper__bg"
              src="@/assets/images/banner2.png"
              alt="banner2"
              width="1180"
              height="700"
              fetchpriority="high"
            >
          </picture>
          <section class="banner-swiper__content">
            <h3>全球发行</h3>
            <p>自助作品发行，一键上架全球多音乐平台，<br>让全世界听到你的好音乐。</p>
            <ul class="plat-icon-list">
              <li><img src="@/assets/images/qq.png" alt=""></li>
              <li><img src="@/assets/images/kg.png" alt=""></li>
              <li><img src="@/assets/images/kw.png" alt=""></li>
              <li><img src="@/assets/images/kge.png" alt=""></li>
              <br>
              <br>
              <li><img src="@/assets/images/spotify.png" alt=""></li>
              <li><img src="@/assets/images/kkbox.png" alt=""></li>
              <li><img src="@/assets/images/youtube.png" alt=""></li>
              <li><img src="@/assets/images/apple_music.png" alt=""></li>
              <li><img src="@/assets/images/joox.png" alt=""></li>
            </ul>
          </section>
        </el-carousel-item>
        <el-carousel-item key="banner3">
          <picture>
            <source srcset="@/assets/images/banner3.webp" type="image/webp">
            <img
              class="banner-swiper__bg"
              src="@/assets/images/banner3.png"
              alt="banner3"
              width="1180"
              height="700"
              fetchpriority="high"
            >
          </picture>
          <section class="banner-swiper__content">
            <h3>专业TME版权服务</h3>
            <p>
              系统全网侵权监控，支持自助版权投诉发起，专职腾讯音乐法务团队在线服务，<br>
              确权反馈实时同步，保障每首歌曲合法利益。
            </p>
            <el-button type="primary" size="large" @click="handleClick('content')">{{ homeBtnText2 }}</el-button>
          </section>
        </el-carousel-item>
      </el-carousel>

      <div class="main">
        <ul class="intro_wrap">
          <li class="intro">
            <span class="icon content_manage" />
            <small class="desc">{{ $t('home.contentManageDesc') }}</small>
          </li>
          <li class="intro">
            <span class="icon self_publish" />
            <small class="desc">{{ $t('home.selfPublishDesc') }}</small>
          </li>
          <li class="intro">
            <span class="icon data_service" />
            <small class="desc">{{ $t('home.dataServiceDesc') }}</small>
          </li>
          <li class="intro">
            <span class="icon cp_protect" />
            <small class="desc">{{ $t('home.cpProtectDesc') }}</small>
          </li>
          <li class="intro">
            <span class="icon fast_sign" />
            <small class="desc">{{ $t('home.fastSignDesc') }}</small>
          </li>
          <li class="intro">
            <span class="icon fast_settlement" />
            <small class="desc">{{ $t('home.fastSettlementDesc') }}</small>
          </li>
        </ul>

        <!-- 入驻厂牌 -->
        <section class="comp_wrap">
          <p class="comp_tit">入驻厂牌</p>
          <p class="comp_subTit">知名厂牌纷沓入驻， 与您携手共创音乐</p>
          <picture>
            <source srcset="@/assets/images/comp_list.webp" type="image/webp">
            <img
              width="1110"
              height="460"
              src="@/assets/images/comp_list.png"
              alt="comp_list"
              fetchpriority="high"
            >
          </picture>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'

dayjs.extend(customParseFormat)
const OUTDATE = dayjs('2024-05-31 23:59:59', 'YYYY-MM-DD HH:mm:ss')

export default {
  name: 'Home',
  data() {
    return {
      showAiSkip: dayjs().isBefore(OUTDATE)
    }
  },
  computed: {
    ...mapGetters(['hasLogin', 'notRegister']),

    /**
     * @returns{String}
     */
    homeBtnText1() {
      return this.notRegister ? '立即入驻' : '用户中心'
    },

    /**
     * @returns{String}
     */
    homeBtnText2() {
      return this.notRegister ? '立即入驻' : '版权申诉'
    }
  },
  methods: {
    handleClick(type = 'person') {
      if (this.hasLogin) {
        type === 'person' ? this.$store.dispatch('EnterHome') : this.$router.push({ name: 'outsideCpTortList' })
      } else {
        this.$store.commit('login', true)
      }
    },
    handleSkipAi() {
      window.location.href = '/ai_publish/index'
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .el-carousel__arrow {
    background-color: transparent;

    .el-icon-arrow-left, .el-icon-arrow-right {
      font-size: 32px;
    }
  }

  .el-carousel__indicator {
    position: relative;
    width: 63px;
    height: 10px;
    padding: 0;
    border-radius: 24px;
    background: #FFFFFF1F;

    &:not(:first-child) {
      margin-left: 20px;
    }

    .el-carousel__button {
      position: absolute;
      top: 0;
      width: 100%;
      height: 100%;
      border-radius: 24px;
    }

    &.is-active {
      width: 118px;
      background-color: #fff;
    }
  }
}

.home {
  overflow-y: auto;
  background-color: #000;
  background: linear-gradient(8.55deg, #001D48 6.16%, #000000 92.47%);
  display: flex;
  flex-direction: column;
  color: #fff;
}
@keyframes scala1 {
  0% {
    transform: scale(0)
  }
  100% {
    transform: scale(1)
  }
}

.home_block1 {
  flex-grow: 1;
  width: 100%;
  overflow: hidden;
  position: relative;

  .skip-wrapper {
    position: absolute;
    top: 30px;
    right: 0;
    z-index: 999;

    img {
      width: 180px;
      height: auto;
      border-radius: 12px 0 0 12px;
      cursor: pointer;
    }

    i {
      position: absolute;
      top: 5px;
      right: 5px;
      font-size: 18px;
      color: #999;
      cursor: pointer;
      z-index: 1;
    }
  }

  .banner-swiper {
    height: 700px;

    &__bg {
      margin-left: 40%;
      object-fit: cover;
      position: absolute;
      top: 0;
      z-index: -1;
    }

    &__content {
      position: relative;
      z-index: 1;
      width: 1200px;
      margin: 80px auto 0;

      .plat-icon-list {
        margin-top: 40px;

        li {
          display: inline-block;
          margin-right: 36px;

          img {
            width: 192px;
            height: 85px;
          }
        }
      }

      h3 {
        font-size: 54px;
        font-weight: bold;
        line-height: 80px;
      }

      p {
        // max-width: 730px;
        margin-top: 30px;
        font-size: 27px;
        font-weight: bold;
        line-height: 40px;
      }

      button {
        margin-top: 65px;
        width: 150px;
        height: 54px;
        font-size: 24px;
      }
    }
  }

  .main {
    width: 1200px;
    // height: 500px;
    margin: 80px auto 0;
    text-align: center;
  }

  .intro_wrap {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    .intro {
      display: inline-block;
      width: 370px;
      text-align: center;
      border-radius: 5px;
      // background: rgba(0, 0, 0, 0.2);
      color: #fff;
      animation: scala1 1s;
      animation-fill-mode: both;
      padding-bottom: 30px;

      .icon {
        display: inline-block;
        width: 160px;
        height: 160px;
        background: url('~@/assets/images/home_intro.png') -0px -0px no-repeat;

        &.content_manage {
          background-position: -0px -0px;
        }
        &.self_publish {
          background-position: -160px -0px;
        }
        &.data_service {
          background-position: -320px -0px;
        }
        &.cp_protect {
          background-position: -480px -0px;
        }
        &.fast_sign {
          background-position: -640px -0px;
        }
        &.fast_settlement {
          background-position: -800px -0px;
        }
      }

      .desc {
        margin-top: 24px;
        display: block;
        font-size: 18px;
        line-height: 24px;
        color: #fff;
      }
    }
  }

  .comp_wrap {
    margin-top: 100px;
    padding-bottom: 175px;

    .comp_tit {
      line-height: 45px;
      font-size: 30px;
      font-weight: bold;
    }

    .comp_subTit {
      line-height: 40px;
      font-size: 18px;
      font-weight: 600;
    }

    img {
      margin-top: 40px;
    }
  }
}
</style>
